export const useAuth = () => {
  let isLoggedIn = false;

  // Retrieve the token from storage (e.g., localStorage or sessionStorage)
  const accessToken = localStorage.getItem("access_token"); // Custom function to retrieve token

  if (accessToken) {
    isLoggedIn = true;

    // Decode the token to get user details
    const decoded: any | null = getUserDetailsFromJWT(accessToken);

    if (!decoded) {
      isLoggedIn = false; // Invalid token (couldn't decode)
    } else if (decoded.exp * 1000 < Date.now()) {
      // Check if the token has expired (exp is in seconds, Date.now() returns milliseconds)
      // Clear the token from storage
      localStorage.removeItem(`access_token`);
      localStorage.removeItem(`auth`);

      isLoggedIn = false; // Expired token, user is not logged in
    }
  }

  return isLoggedIn;
};

export const getUserDetailsFromJWT = (token: string) => {
  try {
    // Decoding the base64-encoded payload part of the JWT
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    // If the decoding fails or the token is invalid, return null
    return null;
  }
};
